import React from 'react';
export const MockAuthProvider = ({ children }) => {
  // Provide a fake user and token context
  return <>{children}</>;
};